import { IconTrash } from "@tabler/icons-react"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { ActionIcon, DateCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useDeleteRefreshTokenMutation } from "./hook"

export type Props = {
  id: number
  onClick: (id: number) => void
}

const columnHelper = createColumnHelper<AdminResponses.RefreshTokenLogs>()
export const useRefreshTokenColumns = () => {
  const { mutate: deleteRefreshToken } = useDeleteRefreshTokenMutation()

  return useMemo<ColumnDef<AdminResponses.RefreshTokenLogs, any>[]>(
    () => [
      columnHelper.accessor("id", {
        header: "ID",
        enableSorting: false,
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("user.email", {
        header: "User Email",
        enableSorting: false,
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("adminEmail", {
        header: "Admin Email",
        enableSorting: false,
        cell: (info) => <TextCell value={info.getValue()} />,
      }),
      columnHelper.accessor("isAdmin", {
        header: "isAdmin",
        enableSorting: false,
        cell: (info) => {
          const isAdmin = info.getValue()
          if (isAdmin) return <TextCell value="TRUE" />
          return <TextCell value="FALSE" />
        },
      }),
      columnHelper.accessor("createdAt", {
        header: "createdAt",
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        sortingFn: "datetime",
      }),
      columnHelper.accessor("updatedAt", {
        header: "updatedAt",
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        sortingFn: "datetime",
      }),
      columnHelper.accessor("deletedAt", {
        header: "Deleted",
        id: "action-cell-deleted",
        enableSorting: false,
        cell: ({ row, getValue }) => {
          const deletedAt = getValue()
          if (deletedAt) return <TextCell value="TRUE" />
          return (
            <ActionIcon
              icon={<IconTrash />}
              onClick={() => deleteRefreshToken(row.original.id)}
            />
          )
        },
      }),
    ],
    [deleteRefreshToken]
  )
}
